<template>
  <div class="background">
    <div style="width: 1200px;margin: 0 auto;">
      <img src="../../assets/img/bg_bg.png" alt="" class="bg_bg">
    </div>
    <div class="background_item">
      <div class="item_title">背调流程</div>
      <div class="flex mTop60">
        <div>
          <div class="timeline_item">
            <div class="flex">
              <div class="timeline_box">
                <div class="timeline">1</div>
              </div>
              <div class="timeline_content">
                <div class="timeline_title">选择背调项目</div>
                <div class="timeline_info mTop10">全面的背调选项，满足各种需求</div>
              </div>
            </div>
          </div>
          <div class="timeline_item">
            <div class="flex">
              <div class="timeline_box">
                <div class="timeline">2</div>
              </div>
              <div class="timeline_content">
                <div class="timeline_title">提交背调人信息</div>
                <div class="timeline_info mTop10">只需姓名/电话/手机号即可背调</div>
              </div>
            </div>
          </div>
          <div class="timeline_item">
            <div class="flex">
              <div class="timeline_box">
                <div class="timeline">3</div>
              </div>
              <div class="timeline_content">
                <div class="timeline_title">进行支付</div>
                <div class="timeline_info mTop10">项目多，价格低</div>
              </div>
            </div>
          </div>
          <div class="timeline_item">
            <div class="flex">
              <div class="timeline_box">
                <div class="timeline">4</div>
              </div>
              <div class="timeline_content">
                <div class="timeline_title">发送链接给背调人</div>
                <div class="timeline_info mTop10">操作简单，极速通知</div>
              </div>
            </div>
          </div>
          <div class="timeline_item">
            <div class="flex">
              <div class="timeline_box">
                <div class="timeline">5</div>
              </div>
              <div class="timeline_content">
                <div class="timeline_title">签署背调协议</div>
                <div class="timeline_info mTop10">安全可靠，值得信赖</div>
              </div>
            </div>
          </div>
          <div class="timeline_item">
            <div class="flex">
              <div class="timeline_box last_box">
                <div class="timeline">6</div>
              </div>
              <div class="timeline_content">
                <div class="timeline_title">生成背调报告</div>
                <div class="timeline_info mTop10">报告秒出，更省时</div>
              </div>
            </div>
          </div>
        </div>
        <div class="bg_img">
          <img src="../../assets/img/bg_img.png" alt="">
        </div>
      </div>
    </div>
    <div class="background_item">
      <div class="item_title title2">SaaS平台的背景调查</div>
      <div class="flex justify-content-between mTop80">
        <div class="item2">
          <img src="../../assets/img/bg_img1.png" alt="" class="item_img">
          <div class="item2_title mTop30">多平台</div>
          <div class="item2_info mTop10">同时支持手机端电脑端</div>
        </div>
        <div class="item2">
          <img src="../../assets/img/bg_img2.png" alt="" class="item_img">
          <div class="item2_title mTop30">易理解</div>
          <div class="item2_info mTop10">易操作、流畅清晰</div>
        </div>
        <div class="item2">
          <img src="../../assets/img/bg_img3.png" alt="" class="item_img">
          <div class="item2_title mTop30">纯线上</div>
          <div class="item2_info mTop10">添加候选人、背调授权等全流程线上完成</div>
        </div>
      </div>
      <div class="flex justify-content-between mTop30">
        <div class="item2">
          <img src="../../assets/img/bg_img4.png" alt="" class="item_img">
          <div class="item2_title mTop30">高效</div>
          <div class="item2_info mTop10">最快1秒出报告</div>
        </div>
        <div class="item2">
          <img src="../../assets/img/bg_img5.png" alt="" class="item_img">
          <div class="item2_title mTop30">DIY背调项目</div>
          <div class="item2_info mTop10">多维度背调项目，满足企业的不同需求</div>
        </div>
        <div class="item2">
          <img src="../../assets/img/bg_img6.png" alt="" class="item_img">
          <div class="item2_title mTop30">公正合规</div>
          <div class="item2_info mTop10">数据客观真实、来源合法合规</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      
    };
  },
  mounted: function() {
    this.$store.dispatch("first_nav_change", "2-1");
  },
  computed: {},
  methods: {
    
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/background.vue